import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import Control from "../Control";
import SelectFirm from "../SelectFirm/SelectFirm";

const FirmForm = ({theme = 'white', width, data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Firm' : 'Add Firm'}</div>
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='NAME'
                       label='Name'
                       value={data.NAME}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='ADDRESS'
                       label='Address'
                       value={data.ADDRESS}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='CITY'
                       label='City'
                       value={data.CITY}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType={isFilter ? 'text' : 'email'}
                       name='EMAIL'
                       label='Email'
                       value={data.EMAIL}
                       handleParentChange={handleParentChange}
                />
                <div className='form-address'>
                    <div className='form-state'>
                        <Dropdown theme={theme}
                                  optionsType='states'
                                  optionKey='abbr'
                                  optionLabelKey='name'
                                  value={data.STATE}
                                  valueKey='STATE'
                                  label='State'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                    </div>
                    <div className='form-zip'>
                        <Input theme={theme}
                               valueType='text'
                               name='ZIP'
                               label='Zip'
                               value={data.ZIP}
                               handleParentChange={handleParentChange}
                        />
                    </div>
                </div>
                <Input theme={theme}
                       width={width}
                       valueType='phone'
                       name='PHONE'
                       label='Phone'
                       value={data.PHONE}
                       handleParentChange={handleParentChange}
                />
                <SelectFirm theme={theme}
                            width={width}
                            value={data.PARENT_FIRM}
                            valueKey='PARENT_FIRM'
                            label='Parent Firm'
                            data={data}
                            handleParentChange={handleParentDropdownChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='WEBSITE'
                       label='Website'
                       value={data.WEBSITE}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='CRM_ID'
                       label='CRM ID'
                       value={data.CRM_ID}
                       handleParentChange={handleParentChange}
                />
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

FirmForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default FirmForm;